import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
// import * as Cookies from 'js-cookie'

import mutations from './mutations';
import getters from './getters'
import actions from './actions';
import PickupModule from './modules/pickup'
import FolderSettingsModule from './modules/forlderSettings'

Vue.use(Vuex);

export const initialState = () => {
    return {
        token: null,
        user: {
            // nombre:'',
            // apellido:'',
            // dni:'',
            // mail:'',
            // empresa: {
            //     nombre :''
            // },
            // shortname:'',
            // logout:''
            sector:'',
            locacion:''		
        },
        related: [],
        historyUrl: null,
        menu: [],
        actions: {},
        profile:{},
        jwtExpired: false,
        permissions: [],
        search: {},
        estadoEmpresa: null,
        dropzoneImg: false,
        validateSection: false,
        sections: {},
        limit: 25,
        loading: false,
        onBoardingList: [],
        userList: {},
        activateDate: false,
        carteleraHome: false,
        sectoresBirthdays: [],
        sectoresRecentHired: [],
        popupMantenimientoVisualizations: 0,
        popupSichernVisualizations: 0,
        popupFileUploadLicensesVisualizations: 0,
        msgOutage:'',
        notifyPushVisualizations: 0,
        notifyPush: {},
        SSOData: {},
        documentSearch: {},
        documentsWaiting: {},
        newDocumentsWaiting: {},
        payrollStatus: {},
        peopleOnboarding: false,
        companyLogo: '',
        queryParams: {
            params: {
                factory: ''
            }
        },
        cleanAction:[]
    }
};

const state = initialState();

export default new Vuex.Store({
    state,
    mutations,
    getters,
    actions,
    modules: {
        pickup: PickupModule,
        folderSettings: FolderSettingsModule
    },
    plugins: [createPersistedState({
        key: 'vuex-onboarding'
    })],
    strict: false //In strict mode, whenever Vuex state is mutated outside of mutation handlers, an error will be thrown.
})